<template>
    <div :class="['container', { 'container-dark': theme_dark }]">
      <div class="nav-top">
        <div class="nav-left" @click="back()">
          <img src="../../assets/img/返回箭头.png" class="nav-img" />
        </div>
        <div class="nav-middle">修改昵称</div>
        <div class="nav-right">
            <span class="nav-lable ub ub-pc ub-ac" @click="save()" v-if="chosed != 3">保存</span>
            <img src="../../assets/img/返回箭头.png" class="nav-img none" />
        </div>
      </div>
  
      <div class="txt ub">
        <input type="text" v-model="nick" class="ub-f1" readonly />
      </div>
  
      <ul class="ub ub-ver sort">
        <div class="ub ub-pc ub-ac1">
          <li :class="chosed==0 ? 'sex-on' : ''">
            <div class="ub ub-ver">
              <span @click="chosesex('', 0)" >不限</span>
              <img v-if="chosed==0" class="on-img" src="../../assets/img/new2024/rank-on2.png" alt="">
            </div>
          </li>
          <li :class="chosed==1 ? 'sex-on' : ''">
            <div class="ub ub-ver">
              <span @click="chosesex('男生',1)" >男生</span>
              <img v-if="chosed==1" class="on-img" src="../../assets/img/new2024/rank-on2.png" alt="">
            </div>
          </li>
          <li :class="chosed==2 ? 'sex-on' : ''">
            <div class="ub ub-ver">
              <span @click="chosesex('女生',2)" >女生</span>
              <img v-if="chosed==2" class="on-img" src="../../assets/img/new2024/rank-on2.png" alt="">
            </div>
          </li>
          <li :class="chosed==3 ? 'sex-on' : ''">
            <div class="ub ub-ver ub-pc ub-ac">
              <span @click="up_nick(3)" >自定义</span>
              <img v-if="chosed==3" class="on-img" src="../../assets/img/new2024/rank-on2.png" alt="">
            </div>
          </li>
        </div>
        
        
        <div class="ub ub-ac ub-pc ub-ver" v-if="vip_level==0 && chosed==3">
          <label class="vip-tip">
            此功能为会员特权功能，
            <a @click="goto_vip()">点击成为会员~</a>
          </label>
        </div>
        
      </ul>
  
      <div class="nick">
        <ul class="ub ub-ac1 item" v-for="(item, index) in arr" :key="index">
          <span v-for="(item_sub, index_sub) in item" :key="index_sub" :class="{'on':item_sub.on == 1}" @click="choseNick(index, index_sub)">{{item_sub.nick.length > 6 ? item_sub.nick.substr(0,5) + '...' : item_sub.nick}}</span>
        </ul>

        <div class="ub ub-pc ub-ac">
          <div class="btn-change" @click="changeNick()" v-if="chosed!=3">
            <button class="change-item"><span>换一批</span></button>
          </div>
        </div>
        
        
        <div style="padding: 0.8em;" v-if="chosed==3" class="custom-name">
          <div class="ub ub-ver">
            <div class="take-avatar ub ub-ver">
              <span>嗨~！</span>
              <span>你叫什么名字！</span>
            </div>
            <span class="take-nick">现在取一个响亮的昵称吧</span>
          </div>
          <div class="ub">
            <input @input="handleInput" type="text" placeholder="请输入自定义昵称" v-model="nick_new"  class="txt ub-f1" />
          </div>
          <div class="ub ub-ae nick-length">
            <span >{{ nick_new.length }}/6字</span>
          </div>
          <span class="state-tip">{{tip}}</span>
          <div class="ub ub-ver ub-ac" v-if="check_state!='待审核'">
            <div class="btn ub ub-pc ub-ac" @click="update_nick()">完成</div>
          </div>
        </div>
      </div>
  
      <dlg ref="myForm_2"></dlg>
    </div>
  </template>
  
  <script>
  import * as tool from "../../api/common";
  import { mapMutations, mapActions } from "vuex";
  import Form from "@/components/Form";
  export default {
    components: {
      dlg: Form
    },
    data() {
      return {
        nick: "xxxx",
        nick_new: "",
        arr: [],
        sex: "",
        check_state: "",
        tip:"",
        vip_level:1,
        chosed:0,
        theme_dark: false
      };
    },
  
    mounted() {
      //切换深色模式
      this.theme_dark = tool.is_theme_dark(this);
      this.nick = this.$route.params.nick;
      this.init_page();
      this.init_page2();
    },
    watch: {
      nick_new(newVal) {
      if (newVal.length > 6) {
        this.$toast.center("昵称不能超过6个字符");
        this.nick_new = newVal.slice(0, 6);
      }
    }
    },
  
    methods: {
      ...mapMutations(["get", "post"]), //引入方法
      ...mapActions(["act_reload_userinfo","act_get_userinfo"]), //引入方法
  
      back() {
        this.$router.go(-1); //返回上一层
      },
      goto_vip() {
        this.$router.push({ name: "vip_center" });
      },
      init_page() {
        var self = this;
        var count = 24;
        var sex = this.sex;
        self.get({
          url: "/App/GetNick/?count=" + count + "&sex=" + sex,
          success: function (data_serve) {
            for (var i in data_serve) {
              data_serve[i].on = 0;
            }
            self.arr = tool.slice_arry(data_serve, 4);
          },
          error: function (err) {},
        });
      },
  
      init_page2() {
        var self = this;
        var uid = self.$store.state.uid;
  
        self.get({
          url: "/App/GetUser_Update/?uid=" + uid + "&field_name=nick",
          success: function (data_serve) {
            //console.log(JSON.stringify(data_serve));
            if (data_serve.val_new) {
            self.nick_new = data_serve.val_new;
            self.check_state = data_serve.check_state;
            }
            if(data_serve.check_state=="待审核"){
              self.tip="等待平台审核，审核通过后即可使用自定义昵称"
            }
            if(data_serve.check_state=="失败"){
              self.tip="昵称审核失败，请遵守平台相关规则，多次审核失败将影响此功能的使用"
            }
            if(data_serve.check_state=="通过"){
              self.tip="恭喜你，昵称审核通过"
            }
  
  
          },
          error: function (err) {},
        });
        self.act_get_userinfo({
          uid: uid,
          success: function (u) {
           //console.log(JSON.stringify(u));
            self.vip_level = u.vip_level;
          },
        });
      },
  
      changeNick() {
        this.init_page();
      },
  
      chosesex(sex, chosed) {
        this.sex = sex;
        this.chosed = chosed;
        this.init_page();
      },
      up_nick(chosed) {
        var skipWxCheck = this.$store.state.skipWxCheck;
        if (!skipWxCheck) {
          //检测是否关注公众号
          var wxInfo = this.$store.state.wxInfo;
          if(wxInfo == ""){
            this.show_sys_GuanzhuWx();
            return false;
          }
        }
        
        this.arr = [];
        this.chosed = chosed;
      },
  
      choseNick(index1, index2) {
        var a1 = this.arr.length;
        var a2 = this.arr[0].length;
        for (var i = 0; i < a1; i++) {
          for (var j = 0; j < a2; j++) {
            this.arr[i][j].on = 0;
          }
        }
        this.arr[index1][index2].on = 1;
        var txt = this.arr[index1][index2].nick;
        this.nick = txt;
      },
  
      save() {
        var nick = this.nick;
        if (tool.trim(nick) == "") {
          alert("请输入昵称");
        } else {
          //后台保存信息
          var self = this;
          var uid = this.$store.state.uid;
          var send_data = { nick: nick };
          var data = {
            url: "/App/User_ModifyBaseInfo",
            data: {
              uid: uid,
              data: JSON.stringify(send_data),
            },
            success: function (data_serve) {
              if (data_serve.state == "1") {
                self.act_reload_userinfo({
                  uid: uid,
                  success: function (info) {
                    self.back();
                  },
                });
              }
            },
          };
          self.post(data);
        }
      },
  
      //关注公众号提示
      show_sys_GuanzhuWx() {
        var qrcode_url = require('../../assets/img/qrcode_xhc.jpg');
        var gzh_name = '小火柴';
        var code_link='https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI1NzM4MTAzOQ==#wechat_redirect';
        //加载dic信息
        var sysdic = this.$store.state.sysdic;
        if(sysdic){
          qrcode_url = sysdic.wx_gzh_qrcode;
          gzh_name = sysdic.wx_gzh_name;
        }
  
        var h = '<div style="line-height:1.6em;font-size:.85em;"><label style=" font-weight: bold;font-size:1.1em;">当前版本过低，<label style=" font-weight: bold;font-size:1.1em;color:red;">"自定义昵称"</label>功能无法使用</label>，请关注公众号【<a style="color: rgb(186, 97, 255)" href='+code_link+'>'+ gzh_name +'<a/>】，开启自定义昵称功能~<div>'
          + '<div class="ub ub-ac ub-pc dlg-img"><img src="' + qrcode_url + '"  style="margin: 1rem 0"/></div>'
          + '<div style="line-height:1.6em; text-align:center;">长按开启自定义昵称功能<div>'
        this.$refs.myForm_2.show(h, {
          type: 'alert',
          confirmText: '长按上方二维码',
          titleText: '温馨提示',
          data: ''
        });
      },
  
      update_nick() {
        var self = this;
        var self = this;
  
        if(self.vip_level==0){
          this.$toast.top("此为会员功能~");
          return false;
        }
  
         if(self.nick_new==""){
          self.$toast.center("请输入自定义昵称~");
           return false;
        }
  
        if(self.nick_new.length>=6){
          self.$toast.center("自定义昵称不能太长~");
           return false;
        }
  
         if(self.nick_new==self.nick){
          self.$toast.center("你还没自定义呢");
           return false;
        }
  
        var nick = self.nick;
        var nick_new = self.nick_new;
        var uid = self.$store.state.uid;
        var data_send = {
          uid: uid,
          field_name: "nick",
          val_old: nick,
          val_new: nick_new,
          check_state: "待审核",
        };
        var strsend = JSON.stringify(data_send);
        this.post({
          url: "/App/UpDate_User",
          data: { uid: uid, strsend: strsend },
          success: function (serve_data) {
            if (serve_data.state == "1") {
              self.$toast.center("修改成功，等待审核~");
              self.check_state = "待审核";
              self.tip="等待平台审核，审核通过后即可使用自定义昵称";
              
              var bll_id = serve_data.id || "";
              var msg = {
                  "txt": "昵称审核",
                  "desc": "你申请的昵称已提交审核专员进行审核，请耐心等待一下",
                  "id": bll_id,
                  "nick": nick_new
              }
              tool.send_check_msg(self,"check_nick",msg,true);
            }
          },
        });
      },

      // 获取input值
      handleInput(event) {
      this.nick_new = event.target.value;
    }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .container {
    height: 100vh;
    background-color: #EFEFEF;
  }
  .nav-right {
    padding-right: 0.1rem;
  }

  .nav-lable {
      width: 4rem;
      height: 2rem;
      border-radius: 1rem;
      font-size: 0.75rem;
      background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
      font-size: 0.9rem;
  }

  .txt {
    margin-top: 1rem;
    border-radius: 0.5rem;
    input {
    padding-left: 0.8rem;
    height: 3rem;
    border: 0;
    outline: 0;
    background-color: #FDFDFD;
    font-size: 0.9rem;
    }
  }

  .sort {
    padding: 0.8rem 0.8rem 0.3rem 0.8rem;
    .on-img {
      width: 1.5rem;
    }
    span {
      font-size: 0.9rem;
    }
    .sex-on {
      margin-top: 0.2rem;
      span {
        font-size: 0.9rem;
        font-weight: bold;
      }
    }
    .vip-tip {
      margin-left: 1.25rem;
      margin-top: 1rem;
      color: #333;
      font-size: 0.65rem;
      a {
        color: rgb(186, 97, 255);
        font-size: 0.65rem;
      }
    }
  }

  .nick {
    margin-top: 0.5rem;
    padding: 0.8rem;
    min-height: 20rem;
    background: #FDFDFD;
    border-radius: 1rem;
    .item {
      margin-bottom: 1.5rem;
      color: #333;
      .on {
        color: #BA61FF;
      }
    }
    span {
      font-size: 0.8rem;
    }
    .btn-change {
        margin-top: 1.5rem;
        font-size: 0.75rem;
        border: none;
        border-radius: 1rem;
    }
    .change-item {
          padding: 0.5rem 1rem;
          background-color: transparent;
          position: relative;
          background: transparent;
          border: none;
          cursor: pointer;
          z-index: 1;
          span {
            color: #BA61FF;
            font-size: 0.65rem;
          }
    }
    .change-item::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            border-radius: 2rem;
            padding: 1px;
            background: linear-gradient(to bottom, #8A61FF, #94E7E0);
            z-index: -1;
            -webkit-mask: linear-gradient(black 0 0) content-box, linear-gradient(black 0 0);
            mask: linear-gradient(black 0 0) content-box, linear-gradient(black 0 0);
            -webkit-mask-composite: xor;
            mask-composite: exclude;
    }
    .hello-name {
      margin-top: 1rem;
      width: 8.75rem;
      height: 3rem;
    }
    .take-avatar {
      span {
        font-size: 1.5rem;
        color: #333;
        line-height: 3rem;
      }
    }
    .take-nick {
      margin-top: 1rem;
      color: #333;
    }
    .custom-name {
      margin-top: 1rem;
      input {
        padding-left: 0.8rem;
        height: 3rem;
        border: 0;
        outline: 0;
        background-color: #EFEFEF;
      }
      .nick-length {
        margin-top: 0.5rem;
        span {
          font-weight: bold;
        }
      }
      .btn {
        padding: 0.5rem 3rem;
        color: #fff;
        font-size: 1.1rem;
        border-top-left-radius: 1.25rem;
        border-bottom-left-radius: 1.25rem;
        border-top-right-radius: 1.25rem;
        border-bottom-right-radius: 1.25rem;
        background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
      }
      
      
      .state-tip{
        display: inline-block;
        padding: 0 0 1rem .8rem;
        margin-top: 0.8rem;
        font-size: 0.75rem;
        color: #ff0000;
      }
    }
  }

  .container-dark {
    background-color: #2f2e33;
    .txt {
      input {
        background-color: #2c2b30;
        color: #fdfdfd;
      }
    }
    .sort {
      span {
          color: #fdfdfd;
      }
    }
    .vip-tip {
        color: #888;
    }
    .nick {
      background: #2c2b30;
      .item {
        span {
          color: #fdfdfd;
        }
      }
      .take-avatar {
          span {
            color: #8888;
          }
        }
        .take-nick {
            color: #fdfdfd;
        }
      .custom-name {
        
        .nick-length {
          color: #fff;
        }
        input {
          background-color: #2f2e33;
          color: #fff;
        }
      }
    }
  }
  </style>
  